// src/services/highlightService.ts
export interface Highlight {
  id: string;
  fragmentId: string;
  text: string;
  color: string;
  note?: string;
  startIndex: number;
  endIndex: number;
  fecha?: string;
  chapterId?: string;
}

export interface SaveRequestBody {
  user_id: string;
  book_id: string;
  chapter_id: string;
  highlights: Highlight[];
}

const API = "https://api.virtualpro.co";

const defaultFetchOptions = (token?: string) => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  return { headers };
};

export async function getHighlights(userId: string, bookId: string, token?: string): Promise<Highlight[]> {
  if (!userId || !bookId) return [];
  const url = `${API}/api/highlights/get?userId=${encodeURIComponent(userId)}&bookId=${encodeURIComponent(bookId)}`;

  const res = await fetch(url, {
    method: "GET",
    ...defaultFetchOptions(token),
  });

  if (!res.ok) {
    // If 404 or empty, return []
    try {
      const body = await res.json();
      // try to return body.highlights or body
      if (Array.isArray(body)) return body;
      if (body && Array.isArray((body as any).highlights)) return (body as any).highlights;
    } catch {
      // ignore
    }
    return [];
  }

  const json = await res.json();
  // Accept both array directly or { highlights: [] }
  if (Array.isArray(json)) return json as Highlight[];
  if (json && Array.isArray(json.highlights)) return json.highlights as Highlight[];
  return [];
}

export async function saveHighlights(payload: SaveRequestBody, token?: string): Promise<{ s3_path?: string; public_url?: string } | null> {
  const url = `${API}/api/highlights/upload`;
  const res = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      userId: payload.user_id,
      bookId: payload.book_id,
      highlights: payload.highlights,
    }),
    ...defaultFetchOptions(token),
  });

  const json = await res.json().catch(() => null);

  if (!res.ok) {
    // bubble error
    const msg = json?.error || `Error ${res.status}`;
    throw new Error(msg);
  }

  return json;
}
